import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { customFetcher } from '../useFetch';
import { ILegalClient } from '../../Interfaces/ILegalClient';

const KEY = 'healthcheck';

export interface IDuplicateEmailGroup {
  Email: string;
  Members: ILegalClient[];
}

export const useDuplicateLegalClientEmails = () => {
  const { data, isLoading, isFetching, refetch } = useQuery<
    IDuplicateEmailGroup[]
  >({
    refetchOnWindowFocus: false,
    queryKey: [KEY, 'duplicate-emails'],
    queryFn: () =>
      customFetcher({
        endpoint: '/healthcheck/duplicate-legalclient-emails',
      }),
  });
  return {
    duplicateEmailGroups: data ?? [],
    isLoading,
    isFetching,
    refetch,
  };
};

export interface IMergeLegalClientsBody {
  idTarget: number;
  idSources: number[];
  fieldOverrides?: Partial<{
    FirstName: string;
    LastName: string;
    Surname: string;
    Birthdate: string;
    Birthplace: string;
    Email: string;
    TaxNumber: string;
    SalesTaxNumber: string;
    idArnoTop: number;
  }>;
}

export const useMergeLegalClients = () => {
  const queryClient = useQueryClient();
  const { mutateAsync, isPending } = useMutation({
    mutationFn: (body: IMergeLegalClientsBody) =>
      customFetcher({
        endpoint: '/healthcheck/merge-legalclients',
        method: 'POST',
        body,
      }),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: [KEY] });
    },
  });
  return { mergeLegalClients: mutateAsync, isMergingLegalClients: isPending };
};

export const useClearLegalClientEmail = () => {
  const queryClient = useQueryClient();
  const { mutateAsync, isPending } = useMutation({
    mutationFn: (idLegalClient: number) =>
      customFetcher({
        endpoint: `/healthcheck/legalclient/${idLegalClient}/email`,
        method: 'DELETE',
      }),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: [KEY] });
    },
  });
  return {
    clearLegalClientEmail: mutateAsync,
    isClearingLegalClientEmail: isPending,
  };
};

export const useDeleteLegalClientHealthCheck = () => {
  const queryClient = useQueryClient();
  const { mutateAsync, isPending } = useMutation({
    mutationFn: (idLegalClient: number) =>
      customFetcher({
        endpoint: `/healthcheck/legalclient/${idLegalClient}`,
        method: 'DELETE',
      }),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: [KEY] });
    },
  });
  return {
    deleteLegalClient: mutateAsync,
    isDeletingLegalClient: isPending,
  };
};
